var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-container",class:`color-${_vm.style.textColor} bg-${_vm.style.bgColor}`},[_c('em',{staticClass:"mr-2",class:`fas fa-${_vm.style.icon} ${_vm.style.textColor}`}),_c('div',{attrs:{"dir":"rtl"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }